// extracted by mini-css-extract-plugin
module.exports = {"offices":"_6f25b66c20--offices--21Dwy"};